module.exports = __webpack_public_path__ + "img/csm_Ersa-VERSAFLOW455-01-900x676_82edd70b55.82949db0.png";